/**
 * PC 用グローバルナビ・モバイル用メインメニュー
 * MEMO: PC 用グローバルナビ・モバイル用メインメニューの制御
 */

/**
 * グローバルナビ・メインメニューの制御を初期化
 */
export const initGlobalNav = (): void => {
    /**
     * PC 用グローバルナビ
     * MEMO: Google カスタム検索の呼び出し
     */
    const srchTgls = document.querySelectorAll<HTMLElement>('.j-srch_tgl')
    srchTgls.forEach((tgl) => {
        tgl.addEventListener('click', () => {
            const isOpen = tgl.classList.contains('is-open')
            const child = tgl.firstElementChild
            const srchItem = document.querySelector<HTMLElement>('.p-srch_item')
            const gscInput = document.querySelector<HTMLInputElement>('#gsc-i-id1')

            if(isOpen) {
                tgl.classList.remove('is-open')
                if(child) child.classList.replace('icon-cross', 'icon-search')
                if(srchItem) srchItem.style.display = 'none'
                if(gscInput) gscInput.value = ''
            }
            else {
                tgl.classList.add('is-open')
                if(child) child.classList.replace('icon-search', 'icon-cross')
                if(srchItem) srchItem.style.display = 'block'
                if(gscInput) gscInput.focus()
            }
        })
    })

    /**
     * MENU クリック（SP ポップアップ）
     * MEMO: メニューの表示切換えと Google カスタム検索の呼び出し
     */
    const spPopupTgl = document.querySelector<HTMLElement>('#j-sp_popup_tgl')
    if(spPopupTgl) {
        spPopupTgl.addEventListener('click', () => {
            const label = spPopupTgl.querySelector<HTMLElement>('.p-nav_main_label')
            const img = spPopupTgl.querySelector<HTMLImageElement>('img')
            const overlay = document.querySelector<HTMLElement>('#j-overlay_popup')
            const popup = document.querySelector<HTMLElement>('.p-nav_popup')
            const menu = popup?.querySelector<HTMLElement>('.p-nav_menu')

            if(!spPopupTgl.classList.contains('flg-open')) {
                spPopupTgl.classList.add('flg-open')
                spPopupTgl.style.zIndex = '9999'
                if(label) label.textContent = '閉じる'
                if(img) img.src = img.src.replace('common-icon_menu_list-white.svg', 'common-icon_close-white.svg')
                if(overlay) overlay.style.display = 'block'
                if(popup) popup.style.display = 'block'
                if(menu) menu.classList.add('anmtn-fadein-up')
            }
            else {
                spPopupTgl.classList.remove('flg-open')
                spPopupTgl.style.zIndex = ''
                if(label) label.textContent = 'MENU'
                if(img) img.src = img.src.replace('common-icon_close-white.svg', 'common-icon_menu_list-white.svg')
                if(overlay) overlay.style.display = 'none'
                if(popup) popup.style.display = 'none'
                if(menu) menu.classList.remove('anmtn-fadein-up')

                const closeBtn = document.querySelector<HTMLElement>('.gsc-results-close-btn')
                if(closeBtn) closeBtn.click()
                const srchRow = document.querySelector<HTMLElement>('.p-nav_menu_srch_row')
                if(srchRow) srchRow.style.display = 'none'
            }
        })
    }
  //検索ウィンドウの開閉
    const srchBtn = document.querySelector<HTMLElement>('.p-nav_menu_srch_btn')
    if(srchBtn) {
        srchBtn.addEventListener('click', () => {
            const srchRow = document.querySelector<HTMLElement>('.p-nav_menu_srch_row')
            if(!srchRow) return
            srchRow.style.display = srchRow.style.display==='none' || !srchRow.style.display ? 'block' : 'none'
        })
    }
}
